module.exports = __webpack_public_path__ + "static/img/ko.733836ac.png";